<div class="period relative" [class.period--dense]="dense">
  @if (showMonths) {
    <div class="grid grid-cols-12 mb-1" aria-hidden="true">
      @for (m of monthNumbers; track m) {
        <span class="text-center text-caption" [class.text-vw-ink]="m === month" [class.font-semibold]="m === month"
          [class.text-vw-muted]="m !== month">{{ ('common.months.' + m | translate).slice(0, 1) }}</span>
      }
    </div>
  }
  <div class="relative flex flex-col" [class.gap-1]="!dense" [class.gap-0.5]="dense">
    @for (track of tracks; track track.kind) {
      <div class="period__track relative" [class.h-2.5]="!dense" [class.h-1.5]="dense" [attr.data-kind]="track.kind">
        @for (bar of track.bars; track $index) {
          @if (dense) {
            <span class="period__bar--{{ track.kind }} absolute top-0 h-1.5 rounded-full"
              [style.left.%]="bar.start / 12 * 100" [style.width.%]="(bar.end - bar.start) / 12 * 100"></span>
          } @else {
            <button type="button" class="period__bar period__bar--{{ track.kind }} absolute top-0 h-2.5 rounded-full"
              [style.left.%]="bar.start / 12 * 100" [style.width.%]="(bar.end - bar.start) / 12 * 100"
              [attr.aria-label]="tipFor(bar)" (click)="toggle(bar, $event)"></button>
          }
        }
      </div>
    }
    @if (markerLeft !== null && tracks.length > 0) {
      <span class="period__now absolute -top-[3px] -bottom-[3px] w-0.5 rounded-sm bg-vw-ink pointer-events-none"
        [style.left.%]="markerLeft" aria-hidden="true"></span>
    }
  </div>
  @if (activeBar) {
    <span [style.left.%]="tipLeft" class="period__tip absolute bottom-full -translate-x-1/2 mb-2 z-10 whitespace-nowrap rounded-lg bg-vw-ink px-3 py-1.5 text-body-s text-vw-on-color shadow-lg"
      role="status">{{ tipFor(activeBar) }}</span>
  }
</div>
